import React, { useState } from "react";

const ReadMore = ({ text, limit = 230 }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggle = () => setIsExpanded(!isExpanded);

  // Show limited or full text
  const shownText = isExpanded ? text : text.slice(0, limit);

  return (
    <div>
      <p style={{ textAlign: "justify" }}>
        {shownText}
        {text.length > limit && (
          <>
            {!isExpanded && "... "}
            <span
              onClick={toggle}
             style={{ color: "blue", cursor: "pointer", fontWeight: "500", textAlign: "justify"}}
            >
              {isExpanded ? " Read Less" : " Read More "}
            </span>
          </>
        )}
      </p>
    </div>
  );
};

export default ReadMore;
